/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject10 model module.
 * @module model/InlineObject10
 * @version 1.0.0
 */
class InlineObject10 {
    /**
     * Constructs a new <code>InlineObject10</code>.
     * @alias module:model/InlineObject10
     * @param file {File} 
     * @param academicProgramId {Number} 
     * @param payedAt {Date} 
     */
    constructor(file, academicProgramId, payedAt) { 
        
        InlineObject10.initialize(this, file, academicProgramId, payedAt);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, file, academicProgramId, payedAt) { 
        obj['file'] = file;
        obj['academic_program_id'] = academicProgramId;
        obj['payed_at'] = payedAt;
    }

    /**
     * Constructs a <code>InlineObject10</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject10} obj Optional instance to populate.
     * @return {module:model/InlineObject10} The populated <code>InlineObject10</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject10();

            if (data.hasOwnProperty('file')) {
                obj['file'] = ApiClient.convertToType(data['file'], File);
            }
            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('payed_at')) {
                obj['payed_at'] = ApiClient.convertToType(data['payed_at'], 'Date');
            }
        }
        return obj;
    }


}

/**
 * @member {File} file
 */
InlineObject10.prototype['file'] = undefined;

/**
 * @member {Number} academic_program_id
 */
InlineObject10.prototype['academic_program_id'] = undefined;

/**
 * @member {Date} payed_at
 */
InlineObject10.prototype['payed_at'] = undefined;






export default InlineObject10;

